export enum StageTypes {
  ALL = 'ALL',
  TYPE_ELIMINATION = 'ELIMINATION',
  TYPE_GROUPS = 'GROUPS',
}

export enum ImportTypes {
  TYPE_COMET = 'TYPE_COMET',
  TYPE_FCF = 'TYPE_FCF',
  TYPE_LFB = 'TYPE_LFB',
}

export interface Import {
  id: string
  is_active: boolean
  is_working: false
  last_run: number
  next_run: number
  type: ImportTypes
  url: string
}

export interface Access {
  level: number
}

export interface Round {
  id: string
  is_ended: number
  is_filled: number
  matches_count: number
  name: string
  order: number
  slug: string
}

export interface StageSchema {
  id: string
  groups_total: number
  imports: Import[]
  is_ended: boolean
  is_filled: boolean
  is_started: boolean
  matches_total: number
  name: string
  order: number
  relevance: number
  rounds: Round[]
  scoring: string
  slug: string
  teams_total: number
  tournament_id: string
  type: StageTypes

  access?: Access
  created_at?: number
  deleted_at?: number
  updated_at?: number
}
